import React from 'react';
import PropTypes from 'prop-types';

import InputGroupSideHoc from './InputGroupSideHoc';

function InputSideComponent(props) {
    return <input
        type={props.type}
        className="form-control"
        {...props.input}
        disabled={props.disabled}
        placeholder={props.placeholder}
    />;
}

InputSideComponent.propTypes = {
    disabled: PropTypes.bool,
    input: PropTypes.object.isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string
};

InputSideComponent.defaultProps = {
    type: 'text'
};

export default InputGroupSideHoc(InputSideComponent);